module.exports = __webpack_public_path__ + "img/sharepoint.6a09e62f.png";